<template>
  <div>
    <!-- FAQ Dropdown button code -->
      <b-dropdown text="Help" class="btn-block" variant="success">
        <b-dropdown-item v-b-modal.modalFAQ @click="setFAQ('welcome')">Welcome</b-dropdown-item>
        <b-dropdown-item v-b-modal.modalFAQ @click="setFAQ('getting-started')">Getting Started</b-dropdown-item>
       
      </b-dropdown>

    <!-- Modal -->
    <b-modal id="modalFAQ" size="lg" ok-only :title="faqTitle">
      <iframe :src="faqUrl"></iframe>
    </b-modal>
    <!-- /Modal -->

  </div>
</template>

<script>
export default {
  name: "FAQMenu",
  data: function() {
    return {
      currentFAQ: 'welcome',
      pages: {
        'welcome':          {title: 'Welcome', url: 'faqs/welcome.html'},
        'getting-started':  {title: 'Getting Started', url: 'faqs/getting-started.html'},
       // 'guests':           {title: 'Guests', url: 'faqs/guests.html'},
       // 'recording':        {title: 'Recording', url: 'faqs/recording.html'},
       // 'downloading':      {title: 'Downloading', url: 'faqs/downloading.html'},
       // 'platforms':        {title: 'Platforms', url: 'faqs/platforms.html'},

       /*

 <b-dropdown-item v-b-modal.modalFAQ @click="setFAQ('guests')">Guests</b-dropdown-item>
        <b-dropdown-item v-b-modal.modalFAQ @click="setFAQ('recording')">Recording</b-dropdown-item>
        <b-dropdown-item v-b-modal.modalFAQ @click="setFAQ('downloading')">Downloading</b-dropdown-item>
        <b-dropdown-item v-b-modal.modalFAQ @click="setFAQ('platforms')">Platforms</b-dropdown-item>

       */


      }
    }
  },
  computed: {
    faqUrl() {
      return this.pages[this.currentFAQ].url;
    },

    faqTitle() {
      return this.pages[this.currentFAQ].title;
    }
  },
  methods: {
    setFAQ(page) {
      if (page in this.pages) {
        this.currentFAQ = page;
      }
    }
  }
};
</script>

<style scoped>
  iframe {
    width: 100%;
    height: 600px;
    border: none;
    margin: 0; padding: 0;
  }
</style>